module.exports = __webpack_public_path__ + "img/cover.af1513f7.jpg";